<template>
    <span>{{format()}}</span>
</template>

<script>
import moment from 'moment';
export default {
    name: "DateTimeRender",
    props: {
        value: Number|String,
        separator: {
            type: String,
            default: '-'
        }
    },
    data()
    {
        return {}
    },
    methods:
    {
        format()
        {
            if(!this.value) return '-';
            if(isNaN(this.value)) return this.value;
            return moment(this.value).format(`YYYY${this.separator}MM${this.separator}DD HH:mm:ss`);
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render/DateTimeRender.vue